module.exports = "import React from 'react';\nimport Divider from 'material-ui/Divider';\nimport {Menu, MenuItem} from 'material-ui/Menu';\n\nconst style = {\n  // Without this, the menu overflows the CodeExample container.\n  float: 'left',\n};\n\nconst DividerExampleMenu = () => (\n  <Menu desktop={true} style={style}>\n    <MenuItem primaryText=\"Settings\" />\n    <MenuItem primaryText=\"Help & feedback\" />\n    <Divider />\n    <MenuItem primaryText=\"Sign out\" />\n  </Menu>\n);\n\nexport default DividerExampleMenu;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/Divider/ExampleMenu.js
 ** module id = 972
 ** module chunks = 0
 **/